/* eslint-disable */
import React, { Component } from "react";
import { withRouter } from "../../../withRouter";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import cookie from "react-cookies";
import Select from "react-select";
import Swal from "sweetalert2";
import Axios from "axios";
import { apiUrl, adminlimit, clientheaderconfig } from "../../Helpers/Config";
import { GET_LISTDATA } from "../../../actions";
import { encodeValue, removeItem, showRecords, showStatus, showAlert } from "../../Helpers/SettingHelper";
import Header from "../Layout/Header";
import Topmenu from "../Layout/Topmenu";
import Footer from "../Layout/Footer";
import Pagenation from "../Layout/Pagenation";
import { Tooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
var module = "referralsettings";
var moduleName = "Referral Settings";
const Parser = require("html-react-parser");
class List extends Component {
  constructor(props) {
    super(props);
    var companyID = cookie.load("companyID");
    this.state = {
      companyID: companyID,
      totalRecords: 0,
      totalPage: 0,
      currentPage: 1,
      listdata: [],
      loading: true,
      name: "",
      contactnumber: "",
      status: "",
      companyReferralCreditType: "",
      outletDetails:[],
      referralName:""
    };
    this.handleChangeText = this.handleChangeText.bind(this);
  }
  componentDidMount() {
    this.loadList(1);
    this.checkingEnableStatus();
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.listdata !== this.state.listdata) {
      this.setState({
        listdata: nextProps.listdata,
        loading: false,
        totalRecords: nextProps.totalRecords,
        totalPage: nextProps.totalPages,
      });
    }
  }
  sateValChange = (field, value) => {
    if (field === "page") {
      this.setState(
        {
          loading: true,
          currentPage: value,
        },
        function () {
          this.loadList(value);
        },
      );
    }
  };
  removeItem(deleteID) {
    removeItem(deleteID, module, "client", this.sateValChange, this.state.currentPage);
  }
  handleChangeText(event) {
    var name = event.target.name;
    var value = event.target.value;
    this.setState({ [name]: value });
  }
  handleSelectChange(name, value) {
    this.setState({ [name]: value });
  }

  searchList() {
    this.setState({ loading: true }, function () {
      this.loadList(1);
    });
  }
  loadList(offset) {
    var addParams = "";
    if (this.state.name !== "") {
      addParams += "&name=" + this.state.name;
    }
    if (this.state.contactnumber !== "") {
      addParams += "&contactnumber=" + this.state.contactnumber;
    }
    if (Object.keys(this.state.status).length > 0) {
      addParams += "&status=" + this.state.status.value;
    }
    var params = {
      params: "limit=" + adminlimit + "&offset=" + offset + addParams,
      url: apiUrl + module,
      authType: "client",
    };
    this.props.getListData(params);
  }
  resetSearch() {
    this.setState(
      {
        loading: true,
        name: "",
        status: "",
      },
      function () {
        this.loadList(1);
      },
    );
  }

  checkingEnableStatus() {
    Axios.get(apiUrl + `client/checkingEnableStatus`, clientheaderconfig)
      .then((res) => {
        if (res.data.status === "ok") {
          const companyReferralCreditType = res.data.result?.companyReferralCreditType ?? "";
          this.setState({ companyReferralCreditType: companyReferralCreditType !== "" ? { label: companyReferralCreditType, value: companyReferralCreditType } : "" });
        } else {
          this.setState({ companyReferralCreditType: "" });
        }
      })
      .catch(() => {
        this.setState({ companyReferralCreditType: "" });
      });
  }

  updateCreditType() {
    const postData = {
      companyReferralCreditType: this.state.companyReferralCreditType?.value,
    };
    Axios.put(apiUrl + `company/updateSetting`, postData, clientheaderconfig)
      .then((res) => {

        var errMsg = res.data?.message;
        if (res.data.status === "ok") {
          showAlert("Success", errMsg, "success", "No");
        } else {
          showAlert("Error", errMsg, "error", "No");
        }

      })
      .catch(() => { });
  }
  viewQRCode(outletDetails, referralName, e) {
    e.preventDefault();
    if(outletDetails.length>0) {
      this.setState({ outletDetails, referralName }, () => {
        $("#qrmodal").modal("toggle");
      });
    }
  }
  copyLink(itemSlug) {
      toast.success("Link Copied Success", { autoClose: 1000 });
      navigator.clipboard.writeText(itemSlug);
    }

  render() {
    return (
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header {...this.props} currentPage={"referralsettings"} />
          <div className="layout-page">
            <Topmenu />

            <div className="content-wrapper">
              <div className="container-xxl flex-grow-1 container-p-y">
                <div className="row mb-3">
                  <div className="col-lg-10 col-md-6">
                    <h4 className="fw-bold">Referral Settings</h4>
                  </div>
                  <div className="col-lg-2 col-md-6 text-end">
                    <Link to={"/clientpanel/referralsettings/add"}>
                      <button type="button" className="btn btn-outline-primary waves-effect">
                        Add New
                      </button>
                    </Link>
                  </div>
                </div>
                <div className="row mb-4">
                  <div className="col-md-3">
                    <div className="form-floating form-floating-outline mb-4">
                      <input type="text" className="form-control" name="name" onChange={this.handleChangeText} value={this.state.name} />
                      <label>Name</label>
                    </div>
                  </div>

                  <div className="col-md-2">
                    <div className="form-floating form-floating-outline custm-select-box filter-select">
                      <Select
                        value={this.state.status}
                        onChange={this.handleSelectChange.bind(this, "status")}
                        placeholder="Select"
                        options={[
                          { value: "A", label: "Active" },
                          { value: "I", label: "Inactive" },
                        ]}
                      />
                      <label className="select-box-label">Status</label>
                    </div>
                  </div>

                  <div className="col-md-3 mt-2">
                    <button type="button" className="btn btn-primary me-sm-3 me-1 waves-effect waves-light" onClick={this.searchList.bind(this)}>
                      Search
                    </button>
                    <button type="reset" className="btn btn-label-secondary waves-effect" onClick={this.resetSearch.bind(this)}>
                      Reset
                    </button>
                  </div>
                </div>

                <div className="card">
                  <div className="p-1 mt-4">
                    <div className="row">
                      <div className="col-md-8">{parseInt(this.state.totalPage) > 0 && showRecords(this.state.currentPage, this.state.totalRecords, moduleName)}</div>
                      <div className="col-md-4">
                        <div className="row">
                          <div className="col-md-7">
                            <div className="form-floating form-floating-outline custm-select-box filter-select">
                              <Select
                                value={this.state.companyReferralCreditType}
                                onChange={this.handleSelectChange.bind(this, "companyReferralCreditType")}
                                placeholder="Select"
                                options={[
                                  { value: "Credit Immediately", label: "Credit Immediately" },
                                  { value: "After Approved", label: "After Approved" },
                                ]}
                              />
                              <label className="select-box-label">Credit Type</label>
                            </div>
                          </div>
                          <div className="col-md-5 ">
                            <button type="button" className="btn btn-primary waves-light mt-1 pt-2 pb-2" onClick={this.updateCreditType.bind(this)}>
                              Update Type
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <table className="table">
                      <thead>
                        <tr>
                          <th>Actions</th>
                          <th>Title</th>
                          <th>Applicable Outlets</th>
                          <th>Referrer Points</th>
                          <th>Referee Points</th>
                          <th>Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.loading === true ? (
                          <tr>
                            <td colSpan={7} align="center">
                              <div className="spinner-border spinner-border-lg text-primary" role="status">
                                <span className="visually-hidden">Loading...</span>
                              </div>
                            </td>
                          </tr>
                        ) : this.state.listdata.length > 0 ? (
                          this.state.listdata.map((item, index) => {
                            return (
                              <tr key={index}>
                                <td>
                                  <div className="dropdown">
                                    <button type="button" className="btn p-0 dropdown-toggle hide-arrow" data-bs-toggle="dropdown">
                                      <i className="mdi mdi-dots-horizontal"></i>
                                    </button>
                                    <div className="dropdown-menu">
                                      <Link to={"/clientpanel/referralsettings/edit/" + encodeValue(item._id)} className="dropdown-item">
                                        <i className="mdi mdi-pencil-outline me-1"></i>
                                        Edit
                                      </Link>
                                      <a className="dropdown-item" href={void 0} onClick={this.removeItem.bind(this, encodeValue(item._id))}>
                                        <i className="mdi mdi-trash-can-outline me-1"></i>
                                        Delete
                                      </a>
                                    </div>
                                  </div>
                                </td>
                                <td>
                                  <strong>{item.referralTitle}</strong>
                                </td>
                                <td>
                                  {item.referralOutlet !== "" && item.referralOutlet !== null && (
                                    <>
                                      <div data-tooltip-id={`my-tooltip${index}`}>
                                        {" "}
                                        {item.referralOutlet.length > 30 ? item.referralOutlet.substring(0, 30) + "..." : item.referralOutlet}
                                      </div>
                                      {item.referralOutlet.length > 30 && (
                                        <Tooltip id={`my-tooltip${index}`} place="left" clickable render={() => <div>{Parser(item.referralOutlet.split(",").join("<br/>"))}</div>} />
                                      )}
                                      <a href="/" onClick={this.viewQRCode.bind(this, item.outletDetails, item.referralTitle)}>View QR Codes</a>
                                    </>
                                  )}
                                </td>
                                <td>{item.referrerPoints}</td>
                                <td>{item.refereePoints}</td>
                                <td>{showStatus(item.referralStatus)}</td>
                              </tr>
                            );
                          })
                        ) : (
                          <tr>
                            <td className="text-center" colSpan={8}>
                              No Referral Settings Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                  <Pagenation
                    params={{
                      totalRecords: this.state.totalRecords,
                      totalPage: this.state.totalPage,
                      currentPage: this.state.currentPage,
                    }}
                    sateValChange={this.sateValChange}
                  />
                </div>
              </div>

              <Footer />
            </div>
          </div>
        </div>

        <div className="layout-overlay layout-menu-toggle"></div>

        <div className="drag-target"></div>
        <div className="modal fade" id="qrmodal" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
          <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">
                  Referral QR Code
                </h4>
                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div className="modal-body">
                <div className=" mb-4">
                  <div className="card-body mt-3">
                    <div className="row">
                      <div className={`col-md-12 text-center mx-auto`}>
                        <div className="row">
                        {this.state.outletDetails.length>0  && (
                          this.state.outletDetails.map((item)=> {
                            return (
                              <div className={`col-md-6`}>
                            <a href={item.outletQRCodeImage} title="Name"  download={`${this.state.referralName.replaceAll(' ', '-')}-${item.label.replaceAll(' ', '-')}.png`} target="_blank">
                              <div className="d-flex align-items-center flex-column">
                                <img src={item.outletQRCodeImage} alt={item.label} style={{ width: "50%" }} />
                                <div className="user-info text-center">
                                  <h3>{item.label}</h3>
                                  <span className="badge bg-label-primary">Download</span>
                                </div>
                              </div>
                            </a>
                            <div className="input-group mt-2">
                              <input
                                type="text"
                                className="form-control"
                                defaultValue={`${item.outletQRCodeLink}`}
                                aria-describedby="basic-default-password42"
                              />
                              <span className="input-group-text cursor-pointer" onClick={this.copyLink.bind(this, `${item.outletQRCodeLink}`)}>
                                <i className="mdi mdi-content-copy"></i>
                              </span>
                            </div>
                            <hr/>
                          </div>
                            )
                          }) )}
                          </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    );
  }
}

const mapStateTopProps = (state) => {
  var listdata = Array();
  var listdataStatus = "";
  var totalPages = 0;
  var totalRecords = 0;
  if (Object.keys(state.listdata).length > 0) {
    listdataStatus = state.listdata[0].status;
    if (state.listdata[0].status === "ok") {
      listdata = state.listdata[0].result;
      totalPages = state.listdata[0].totalPages;
      totalRecords = state.listdata[0].totalRecords;
    }
  }
  return {
    listdata: listdata,
    totalPages: totalPages,
    totalRecords: totalRecords,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getListData: (datas) => {
      dispatch({ type: GET_LISTDATA, datas });
    },
  };
};

export default withRouter(connect(mapStateTopProps, mapDispatchToProps)(List));
